/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useCallback, useEffect, useMemo, useRef, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";

import DataTable from "examples/Tables/DataTable";
import {
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  Menu,
  MenuItem,
  Switch,
} from "@mui/material";
import applicator from "ajv/dist/vocabularies/applicator";
import colors from "assets/theme/base/colors";
import { useNavigate } from "react-router-dom";
import NotificationItem from "examples/Items/NotificationItem";
// import moment from "moment";
import moment from "moment-timezone";
import debounce from "lodash.debounce";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { exportToExcel } from "utilities";
import { getAllRegistration } from "api";
import { updateRegistration } from "api";

// import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";

export default function data({ fair }) {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);

  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState();
  const [loadingId, setLoadingId] = useState(null);

  const [openConfirm, setOpenConfirm] = useState(false);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const arrStatus = [
    { key: "all", name: "All" },
    { key: "yes", name: "Yes" },
    { key: "no", name: "No" },
  ];
  const [status, setStatus] = useState(arrStatus[0]);

  const [counselled, setCounselled] = useState(arrStatus[0]);

  const [arrIntake, setArrIntake] = useState([{ key: "all", name: "All" }]);
  const [intake, setIntake] = useState(arrIntake[0]);

  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [university, setUniversity] = useState("");

  const lastSearch = useRef("");
  const isFetching = useRef(false);
  const lastApiParams = useRef("");
  const resizeTimeout = useRef(null);
  const didMount = useRef(false);
  const isFirstLoad = useRef(true);

  useEffect(() => {
    const handleResize = () => {
      clearTimeout(resizeTimeout.current);
      resizeTimeout.current = setTimeout(() => {
        // do nothing → just absorb resize re-renders
      }, 300);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const currentYear = new Date().getFullYear();

    const years = [
      "All",
      "Jan 26",
      "Feb 26",
      "Jul 26",
      "Sep 26",
      "Jan 27",
      "Feb 27",
      "Jul 27",
      "Sep 27",
      "Jan 28",
      "Feb 28",
      "Jul 28",
      "Sep 28",
      "Not Decided",
    ];

    const yearOptions = years.map((item) => ({
      key: item.replace(/\s+/g, "_").toLowerCase(), // e.g. "jan_26"
      name: item, // keep original label
    }));

    // setArrIntake([intake, ...yearOptions]);
    setArrIntake(yearOptions);
    setIntake(yearOptions[0]);
    // onSearchData("");

    if (didMount.current) return;

    didMount.current = true;
    getAllRegistrationApi();
  }, []);

  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }

    getAllRegistrationApi();
  }, [search]);

  // useEffect(() => {
  //   if (search !== undefined) {
  //     getAllRegistrationApi();
  //   }
  // }, [search]);

  // const debouncedFetch = useRef(
  //   debounce((searchVal) => {
  //     setSearch(searchVal);
  //   }, 500)
  // ).current;

  const debouncedFetch = useMemo(
    () =>
      debounce((searchVal) => {
        setSearch(searchVal);
      }, 500),
    []
  );

  useEffect(() => {
    return () => {
      debouncedFetch.cancel();
    };
  }, [debouncedFetch]);

  useEffect(() => {
    getAllRegistrationApi();
  }, [page]);

  const getAllRegistrationApi = (isReset = false, isExport = false) => {
    var params = {
      page: page,
      limit: limit, //10000,
      name: search,
      fair: fair?._id,
      isExport: isExport,
    };

    // console.log("____isReset____", isReset, intake);

    if (isReset) {
      params.status = "all";
      params.counselled = "all";
      params.intake = "all";
      params.city = "";
      params.country = "";
      params.university = "";
      params.startDate = "";
      params.endDate = "";
    } else {
      params.status = status?.key || "all";
      params.counselled = counselled?.key || "all";
      params.intake = intake?.name || "all";
      params.city = city || "";
      params.country = country || "";
      params.university = university || "";
      params.startDate = startDate || "";
      params.endDate = endDate || "";
    }

    const key = JSON.stringify(params);
    // 🚀 BLOCK if same API already called
    if (lastApiParams.current === key) return;

    lastApiParams.current = key;

    if (isFetching.current) return; // 🚀 BLOCK duplicate calls
    isFetching.current = true;

    setLoading(true);

    getAllRegistration({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            if (isExport) {
              const dataList = responseJson?.attendees;
              exportToExcel(dataList, "registration.xlsx");
            } else {
              setList(responseJson?.attendees || []);
              setTotal(responseJson?.total || 0);
            }
          }
        }
      })
      .catch((e) => {})
      .finally(() => {
        setLoading(false);
        isFetching.current = false;
      });
  };

  const onSearchData = (val) => {
    if (lastSearch.current === val) return; // 🚀 STOP duplicate
    lastSearch.current = val;
    setPage(1);
    debouncedFetch(val);
  };

  const handleAction = (event, rowId) => {
    // setMenuAnchor(event.currentTarget);
    // setCurrentRowId(rowId);
    navigate("/checkin", { state: { fair: fair, registration: rowId } });
  };

  const columns = useMemo(() => {
    return [
      { Header: "name", accessor: "name", align: "left" },
      { Header: "contact", accessor: "contact", align: "center" },
      { Header: "university", accessor: "university", align: "center" },
      { Header: "Preferred Country", accessor: "country", align: "center" },
      // { Header: "parent contact", accessor: "parent", align: "center" },
      { Header: "intake year", accessor: "intakeYear", align: "center" },
      {
        Header: "main entry",
        accessor: "mainEntry",
        align: "center",
      },
      {
        Header: "registration",
        accessor: "registration",
        align: "center",
      },
      {
        Header: "counselled",
        accessor: "counselled",
        align: "center",
      },
      {
        Header: "actions",
        accessor: "actions",
        align: "center",
      },
    ];
  }, []);

  const handleStatus = (item) => {
    setLoadingId(item?._id);
    var params = {
      counselled: item?.counselled ? false : true,
    };
    updateRegistrationApi(params, item._id);
  };

  const updateRegistrationApi = (params, id) => {
    updateRegistration({
      params: params,
      id: id,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            // notify();
            getAllRegistrationApi();
          }
        }
      })
      .catch((e) => {})
      .finally(() => {
        setLoadingId(null);
      });
  };

  const rows = useMemo(() => {
    var rowsData = [];

    list.map((item) =>
      rowsData.push({
        name: (
          <MDBox>
            <MDTypography
              display="block"
              variant="button"
              fontWeight="medium"
              noWrap
              sx={{
                maxWidth: "350px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {item?.name}
            </MDTypography>
            <MDTypography display="block" variant="caption">
              <b>City:</b> {item?.city}
            </MDTypography>
            {/* <MDTypography display="block" variant="caption">
              <b>Preferred Country:</b> {item?.country}
            </MDTypography> */}
            <MDTypography display="block" variant="caption">
              {item?._id}
            </MDTypography>
          </MDBox>
        ),
        contact: (
          <MDBox sx={{ px: 1, textAlign: "left" }}>
            <MDTypography display="block" variant="caption" noWrap>
              {item?.code} {item?.phone}
            </MDTypography>
            <MDTypography
              display="block"
              variant="caption"
              noWrap
              sx={{
                minWidth: "200px",
                maxWidth: "200px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {item?.email}
            </MDTypography>
          </MDBox>
        ),
        university: (
          <MDBox sx={{ px: 1, textAlign: "left" }}>
            <MDTypography
              display="block"
              variant="caption"
              noWrap
              sx={{
                minWidth: "200px",
                maxWidth: "200px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {item?.university}
            </MDTypography>
            <MDTypography display="block" variant="caption" noWrap>
              <b>Graduation:</b> {item?.checkIn?.graduation || item?.graduation}
            </MDTypography>
          </MDBox>
        ),
        country: (
          <MDBox sx={{ px: 1, textAlign: "left" }}>
            <MDTypography display="block" variant="caption" noWrap>
              {/* {item?.checkIn?.country || item?.country} */}
              {item?.checkIn?.country}
            </MDTypography>
          </MDBox>
        ),
        // parent: (
        //   <MDBox sx={{ px: 1, textAlign: "left", minWidth: 150 }}>
        //     <MDTypography display="block" variant="caption" noWrap>
        //       {item?.checkIn?.parentName}
        //     </MDTypography>
        //     <MDTypography display="block" variant="caption" noWrap>
        //       {item?.checkIn?.parentCountryCode} {item?.checkIn?.parentPhone}
        //     </MDTypography>
        //     {item?.checkIn?.intakeYear && (
        //       <MDTypography display="block" variant="caption" noWrap>
        //         <b>Intake Year:</b> {item?.checkIn?.intakeYear}
        //       </MDTypography>
        //     )}
        //   </MDBox>
        // ),
        intakeYear: (
          <MDBox sx={{ px: 1, textAlign: "center", minWidth: 150 }}>
            <MDTypography display="block" variant="caption" noWrap>
              {item?.checkIn?.intakeYear}
            </MDTypography>
          </MDBox>
        ),
        mainEntry: (
          <MDBox sx={{ px: 1 }}>
            <MDTypography
              display="block"
              variant="caption"
              fontWeight="medium"
              noWrap
              color={item?.checkIn ? "info" : "secondary"}
            >
              {item?.checkIn ? "Yes" : "No"}
            </MDTypography>
          </MDBox>
        ),
        registration: (
          <MDBox sx={{ px: 1, textAlign: "left" }}>
            <MDTypography display="block" variant="caption" noWrap>
              {moment(item?.createdAt).tz("Asia/Kolkata").format("DD MMM YYYY, hh:mm A")}
            </MDTypography>
          </MDBox>
        ),
        counselled: (
          <MDBox sx={{ px: 1 }}>
            {loadingId === item?._id ? (
              <CircularProgress size={24} color="info" />
            ) : (
              <Switch
                checked={item?.counselled}
                onChange={() => handleStatus(item)}
                color="success"
              />
            )}
          </MDBox>
        ),
        actions: (
          <MDBox sx={{ px: 1 }} onClick={(e) => handleAction(e, item?._id)}>
            <MDTypography
              component="a"
              variant="caption"
              color="secondary"
              fontWeight="medium"
              sx={{ cursor: "pointer" }}
            >
              <Icon fontSize="small">arrow_forward</Icon>
            </MDTypography>
          </MDBox>
        ),
      })
    );

    return rowsData;
  }, [list]);

  const handleApplyFilter = () => {
    if (page === 1) {
      getAllRegistrationApi();
    } else {
      setPage(1);
    }
  };

  const handleResetFilter = useCallback(() => {
    setIntake(arrIntake[0]);
    setStatus(arrStatus[0]);
    setCounselled(arrStatus[0]);
    setCity("");
    setCountry("");
    setUniversity("");
    setStartDate("");
    setEndDate("");

    getAllRegistrationApi(true);
  }, [arrIntake, arrStatus]);

  const handleExport = () => {
    getAllRegistrationApi(false, true);
    // exportToExcel(list, "registration.xlsx");
  };

  const ViewFilter = useMemo(() => {
    return (
      <Card sx={{ mb: 3 }}>
        <MDBox
          p={3}
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          flexWrap="wrap"
          gap={2}
        >
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              type="date"
              label="Start Date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              InputLabelProps={{ shrink: true }}
            ></MDInput>
          </MDBox>
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              type="date"
              label="End Date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              InputLabelProps={{ shrink: true }}
            ></MDInput>
          </MDBox>

          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Intake Year"
              // value={JSON.stringify(intake)}
              value={intake.key}
              // onChange={(e) => setIntake(JSON.parse(e.target.value))}
              onChange={(e) => {
                const selected = arrIntake.find((item) => item.key === e.target.value);
                setIntake(selected);
              }}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      maxWidth: 200,
                    },
                  },
                },
              }}
            >
              {arrIntake.map((item, index) => (
                <MenuItem key={item?.key} value={item.key}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>

          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Check-in Status"
              value={JSON.stringify(status)}
              onChange={(e) => setStatus(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      maxWidth: 200,
                    },
                  },
                },
              }}
            >
              {arrStatus.map((item, index) => (
                <MenuItem key={item?.key} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              type="text"
              label="City"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
            ></MDInput>
          </MDBox>
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              label="Preferred Country"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
            ></MDInput>
          </MDBox>
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              label="University"
              value={university}
              onChange={(e) => setUniversity(e.target.value)}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
            ></MDInput>
          </MDBox>

          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Counselled Status"
              value={JSON.stringify(counselled)}
              onChange={(e) => setCounselled(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      maxWidth: 200,
                    },
                  },
                },
              }}
            >
              {arrStatus.map((item, index) => (
                <MenuItem key={item?.key} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>
        </MDBox>
        <MDBox
          mb={3}
          ml={3}
          mr={3}
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          gap={2}
        >
          <MDBox display="flex" flexDirection={{ xs: "column", sm: "row" }} gap={2}>
            <MDButton onClick={handleApplyFilter} variant="gradient" color="info">
              apply
            </MDButton>
            <Button onClick={handleResetFilter} color="error" variant="contained">
              reset
            </Button>
          </MDBox>
          <MDButton onClick={handleExport} color="secondary" variant="contained">
            export
          </MDButton>
        </MDBox>
      </Card>
    );
  }, [
    startDate,
    endDate,
    intake,
    arrIntake,
    status,
    arrStatus,
    city,
    country,
    university,
    handleApplyFilter,
    handleResetFilter,
    handleExport,
  ]);

  return (
    <MDBox>
      {/* <ViewFilter /> */}
      {ViewFilter}
      <Card>
        <MDBox p={3} sx={{ width: "100%", overflowX: "auto" }}>
          <DataTable
            table={{ columns, rows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={true}
            canSearch={true}
            onSearch={onSearchData}
            page={page}
            limit={limit}
            total={total}
            onPageChange={(newPage) => setPage(newPage)}
          />

          {loading && (
            <MDBox display="flex" justifyContent="center" mt={2}>
              <CircularProgress size={24} color="info" />
            </MDBox>
          )}
        </MDBox>
      </Card>
    </MDBox>
  );
}
